export enum EmployeeReviewQuestionType {
    skill = 1,
    custom = 2
}